import React, { Component } from 'react';
import { Drawer, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { BackOnPrimaryIcon } from './icons';
import classNames from 'classnames';
import CustomTypo from './CustomTypo';
const heightHeader = 80
const styles = theme => ({
    drawerPaper: {
        width: '40%',
        height: '100vh',
        backgroundColor: theme.palette.background.drawer,
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '60%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
    large: {
        width: '50%',
        [theme.breakpoints.down('md')]: {
            width: '60%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '70%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
    fixed:{
        position: 'fixed',
    },
    header:{
        padding: theme.spacing(6),
        position: 'fixed',
        height: heightHeader,
        backgroundColor: theme.palette.background.drawer,
        zIndex: 1000,

    },
    content:{
        marginTop: heightHeader,
        padding: theme.spacing(0,6,6,6),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0,3,3,3),
        },
    },
    buttonBack: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        boxShadow:'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8,1,0,1),
        '&:hover': {
                opacity: 0.5,
            },

        position: 'fixed',
        top:theme.spacing(6),
        right:theme.spacing(6),
        zIndex: 1001,
    },
    otherButton: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        boxShadow:'none',
        borderRadius: theme.spacing(10),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1.8,1,0,1),
        backgroundColor: theme.palette.icon.trash,
        '&:hover': {
                opacity: 0.5,
            },

        position: 'fixed',
        top:theme.spacing(6),
        right:theme.spacing(6),
        zIndex: 1001,
    },
    buttonDisable: {
        opacity: 0.2,
    },
    buttonActive: {
        opacity: 1,
    },
    rightHeader: {
        position: 'fixed',
        top:theme.spacing(6),
        right:theme.spacing(6),
        zIndex: 1001,
    },
    customDrawer: {
        backgroundColor: theme.palette.common.white + '!important',
    }
})

class DrawerCustom extends Component {
    render() {
        const { classes, children, onClose, open, large, title, enableBack, fullScreen, rightHeader, backgroundWhite } = this.props;
        console.log("AAAA ")
        return (
            <Drawer
                variant="temporary"
                anchor={'right'}
                open={open}
                onClose={onClose}
                classes={{
                    paper: large ? classNames(classes.drawerPaper, classes.large, backgroundWhite ? classes.customDrawer : undefined) : classNames(classes.drawerPaper, backgroundWhite ? classes.customDrawer : undefined),
                }}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}>
                    {rightHeader&&<Grid item className={classNames(classes.rightHeader)}>{rightHeader}</Grid>}
                    {enableBack&&<Grid item className={classNames(enableBack.icon?classes.otherButton:classes.buttonBack,enableBack.active?undefined:classes.buttonDisable)} onClick={enableBack.action?enableBack.action:()=>onClose()} >
                    {enableBack.icon?enableBack.icon:<BackOnPrimaryIcon/>}
                            </Grid>}
                        {/* </Grid>} */}
                    {/* <Grid item className={classes.fixed}> */}
                        {!fullScreen&&<Grid item container className={classNames(classes.header, backgroundWhite ? classes.customDrawer : undefined)}>
                            <Grid xs={12} item>
                                <CustomTypo variant='h3' color={backgroundWhite ? undefined : 'onPrimary'}>{title}</CustomTypo>
                            </Grid>
                        </Grid>}
                    {/* </Grid> */}

                    {/* {enableBack&&<Grid xs={1} item onClick={()=>onClose()} container justify='flex-end'> */}

                    {fullScreen?children:<Grid item className={classes.content}>
                                            {children}
                                        </Grid>}
            </Drawer>
        );
    }
}

export default withStyles(styles)(DrawerCustom);